/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetUniverseGroupsGroupIdOk
 */
export interface GetUniverseGroupsGroupIdOk {
    /**
     * category_id integer
     * @type {number}
     * @memberof GetUniverseGroupsGroupIdOk
     */
    categoryId: number;
    /**
     * group_id integer
     * @type {number}
     * @memberof GetUniverseGroupsGroupIdOk
     */
    groupId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseGroupsGroupIdOk
     */
    name: string;
    /**
     * published boolean
     * @type {boolean}
     * @memberof GetUniverseGroupsGroupIdOk
     */
    published: boolean;
    /**
     * types array
     * @type {Array<number>}
     * @memberof GetUniverseGroupsGroupIdOk
     */
    types: Array<number>;
}

/**
 * Check if a given object implements the GetUniverseGroupsGroupIdOk interface.
 */
export function instanceOfGetUniverseGroupsGroupIdOk(value: object): value is GetUniverseGroupsGroupIdOk {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    if (!('types' in value) || value['types'] === undefined) return false;
    return true;
}

export function GetUniverseGroupsGroupIdOkFromJSON(json: any): GetUniverseGroupsGroupIdOk {
    return GetUniverseGroupsGroupIdOkFromJSONTyped(json, false);
}

export function GetUniverseGroupsGroupIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseGroupsGroupIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['category_id'],
        'groupId': json['group_id'],
        'name': json['name'],
        'published': json['published'],
        'types': json['types'],
    };
}

export function GetUniverseGroupsGroupIdOkToJSON(json: any): GetUniverseGroupsGroupIdOk {
    return GetUniverseGroupsGroupIdOkToJSONTyped(json, false);
}

export function GetUniverseGroupsGroupIdOkToJSONTyped(value?: GetUniverseGroupsGroupIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_id': value['categoryId'],
        'group_id': value['groupId'],
        'name': value['name'],
        'published': value['published'],
        'types': value['types'],
    };
}

